// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"490":"d39b4b1ce3f3b9d6","972":"8c8820612cf0f187"}[chunkId] + ".js";
};